module.exports = __webpack_public_path__ + "static/media/openhat.a62db465.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/openhat.wav
// module id = 62
// module chunks = 0